import './Label.scss';

type LabelProps = {
    children: React.ReactNode,
};

function Label(props: LabelProps) {

    return (
        <span className="label-text">{props.children}</span>
    );
}

export default Label;
